export const LoadingMixin = {
  data: function() {
    return {
      loading: true
    };
  }
};
